import axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL

const ramses = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Api-key': process.env.VUE_APP_API_KEY,
  },
})

ramses.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token')

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export default ramses
